import { useState } from "react";

export const useTransferOwnership = () => {
  const [selectedMember, setSelectedMember] = useState("");

  return { selectedMember, setSelectedMember };
};
